export default "__VITE_ASSET__D_Xl0NEC__"